import React from 'react';
import classes from '../../css/Us.module.scss';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import { Helmet } from 'react-helmet';
const Us_e = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };
   
    return (
        <div>
        <Helmet>
        <title>Backend Helpers Limited | nosotros </title>
        </Helmet>
         <div className={classes.languageButtons}>
        <Link to="/en"> <button type="button" onClick={() => changeLanguage('en')} className={classes.button_lang}> en</button> </Link>   
        </div>
            <main className={classes['main-content']}>
            <section id="index" className={`${classes.container} ${classes.index}`}>
                <div className={classes['contact-left']}>
                    <h1 className={classes['rw-sentence']}>
                        Desplegamos <br />
                        <span className={classes['bg-title']}>Tú visión</span><br />
                        en la nube
                    </h1>
                </div>
                <div className={`${classes['col-6']} ${classes['col-s-12']} ${classes['padding-1']} `}>
                    <h2 className={classes['text-left']}>QUIENES SOMOS  </h2>
                  <p className={classes.who}>Desde
                    <span className={classes.negrilla}> la migración de sistemas existentes</span> hasta
                    <span className={classes.negrilla}> la implementación desde cero, </span>
                    transformamos rápidamente
                    <span className={classes.negrilla}> sus sistemas para la nube. </span>

                    Somos una <span className={classes.negrilla}>fábrica impulsada por la automatización, </span>

                    centrada en ofrecer
                    <span className={classes.negrilla}> soluciones en la nube seguras,
    confiables y rentables. </span>

                  </p>
                </div> 
                
            </section>
            </main>
            
        </div>
        
    );
};

export default Us_e;